<template>
    <div>
		<EditAccount
			v-if="modalAccount"
			:accountData="{}"
			@closeModal="closeAccount"
			@newAccount="setAccount"
			:name="nameAccount"
		/>
        <b-modal
            ref="modalPayment"
            hide-footer
            size="md"
            no-overflow
            hide-no-focus="true"
            no-close-on-backdrop
            hide-header-close
            hide-header
			@hide="onHide"
        >
            <div class="title-modal">
                <div class="title-text-modal">Executar pagamento</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModal()"
                >
                    <xIcon/>
                </div>
            </div>
            <div class="modal-edicao mb-3 modal-edicao-label mt-6">
                <b-row>
                    <b-col :cols="!isMobile ? '8' : '8' " class="text-parcela mb-3 pr-1">
                        <label class="label-parcela">Data Pagamento</label>
                        <div class="d-flex">
                            <datepicker
								name="payDate"
                                class="w-100"
                                placeholder=""
                                id="paymentExecuteDate"
                                input-class="bg-white"
                                v-model="paymentExecuteDate"
                                :format="formatter"
                                :language="ptBR"
                                :bootstrap-styling="true"
                                data-cy="paymentExecuteDate"
                            />
                        </div>
                    </b-col>

                    <b-col :cols="!isMobile ? '4' : '4'" class="d-block text-parcela pl-1">
                        <span class="label-conta">Valor</span>
                        <b-form-input
                            name="paymentExecuteAmount"
                            class="modal-edicao-input number-class"
                            inputmode="numeric"
                            v-model="paymentExecuteAmount_string"
                            :disabled="true"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :cols="!isMobile ? '8' : '8'" class="pr-1">
                        <span class="label-conta mb-3 text-parcela">
                            Conta
                        </span>
						<SearchSelect
							name="account"
							:options="account.filter(account => account.permitePagamento && !account.inactive)"
							:visibleSuggestion="visibleSuggestion.account"
							:isMobile="isMobile"
							:newRecord="newAccount"
							:clearSelect="clearSelect"
							@changeSelect="changeSelect"
							@handleSuggestion="handleVisibleSuggestion"
							@invalidSearch="validateOptionSearch"
						/>
                    </b-col>
                    <b-col :cols="!isMobile ? '4' : '4'" class="d-flex mb-3 pl-1" style="align-items:end;">
                        <section class="d-block text-parcela" style="width: 100%;">
                            <span class="label-conta">Balance</span>
                            <b-form-input
                                name="accountPayBalance"
                                class="modal-edicao-input number-class"
                                v-model="accountPayBalance"
                                :disabled="true"
                            />
                        </section>
                        <section
                            class="section-btn-add-pay"
                            v-if="havePermissionMultiAccountPay"
                        >
                            <b-button
                                class="btn-pay btn-pay-add"
                                @click="addMethotdPay(paymentExecuteAccount)"
                                :disabled="insufficientBalanceAccount || balanceZero || !paymentExecuteAccount"
                            >
                                +
                            </b-button>
                        </section>
                    </b-col>
                </b-row>
                <section
                    v-if="methods_pay.length"
                    class="table-parcelas mt-2"
                >
                    <b-row
                        v-for="i in methods_pay.length" :key="i"
                        class="mt-1 mb-1 mr-0 justify-items"
                    >
                        <b-col
                            cols="2" class="d-flex label-conta"
                        >
                            <span class="label-conta"># {{ i }}</span>
                        </b-col>
                        <b-col
                            cols="5" class="d-flex label-conta"
                        >
                            <span class="label-conta">{{ methods_pay[i - 1].account.description }}</span>
                        </b-col>
                        <b-col
                            cols="5" class="d-flex label-conta"
                        >
                            <b-form-input
                                :name="`methods_pay-${i}-amount`"
                                class="modal-edicao-input number-class"
                                v-model="methods_pay[i - 1].amount_string"
                                autocomplete="off"
                                placeholder=""
                                inputmode="numeric"
                                :state="validateState(`methods_pay-${i}-amount`)"
                                v-validate="'required|noZeroCurrency'"
                                @input="setNewValueMethodPay(methods_pay[i - 1].amount_string, i - 1)"
                            />
                            <div
                                class="btn-pay btn-pay-del"
                                title="Apagar"
                                @click="delMethodPay(i - 1)"
                            >
                                <Trash2Icon size="24" alt="Apagar"/>
                            </div>
                        </b-col>
                    </b-row>
                </section>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-block text-parcela">
                        <span class="label-conta">Observações</span>
                        <b-form-input
                            name="paymentExecuteComments"
                            class="modal-edicao-input"
                            v-model="paymentExecuteComments"
                            autocomplete="off"
                            placeholder=""
                            v-validate="'maxLength:255'"
                            :state="validateState('paymentExecuteComments')"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal()">Cancelar</b-button>
            <b-button class="mt-3 float-left btn-modal btn-limpar" @click="clearModal()">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="paymentExecute"
                :disabled="invalidForm || invalidFormMulti || saving || invalidFormSearch"
            >
                Salvar
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { possuiPermissao } from "../../helpers/permissions";
	import { numberFormatted, validateNumber, removeAccents } from "@/helpers/common";
	import { PaymentScheduleService } from "../../services/paymentSchedule";
	import emitter from "@/eventBus.js";
	import { mapState } from "vuex";
	import EditAccount from "@/views/Account/EditAccount.vue";
	import SearchSelect from "@/components/SearchSelect.vue";

	export default {
		name: "FormPayment",
		components: {
			Datepicker,
			EditAccount,
			SearchSelect
		},

		props: {
			transactionToPay: {
				type: Array,
				required: true
			},
			showForm: {
				type: Boolean,
				require: true
			},
			isMobile: {
				type: Boolean,
				require: true
			}
		},
		data () {
			return {
				ptBR,
				paymentExecuteAccount: null,
				paymentExecuteAmount: 0,
				paymentExecuteAmount_string: "0,00",
				paymentExecuteComments: "",
				paymentExecuteDate: new Date(),

				methods_pay: [],
				accountPayBalance: "0,00",
				insufficientBalance: false,
				dataPaymentsInstallments: [],
				insufficientBalanceAccount: true,
				methodsPayAmount: 0,
				balanceZero: false,

				havePermissionMultiAccountPay: false,
				invalidFormMulti: true,
				saving: false,
				loading: false,

				paymentScheduleService: new PaymentScheduleService(),

				config: {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				},

				accountOptions: [],
				modalAccount: false,
				visibleSuggestion: {
					account: false
				},
				nameAccount: "",
				invalidSearch: {
					account: true
				},
				newAccount: {},
				account_pay: [],
				invalidForm: true,
				invalidFormSearch: false,
				clearSelect: false
			};
		},

		computed: mapState(["account"]),

		mounted () {
			this.showPayment(this.transactionToPay);
			const paramsUser = localStorage.params ? (JSON.parse(localStorage.params)) : {};
			this.havePermissionMultiAccountPay = possuiPermissao("GER_P_MULTI_ACCOUNT");
			this.invalidFormMulti = this.havePermissionMultiAccountPay;
		},

		methods: {
			onHide (bvEvent) {
				if (bvEvent.trigger === "esc") {
					this.closeModal();
				}
			},
			closeModal () {
				this.clearModal();
				this.$emit("closeForm", true);
			},

			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			getAccountPayBalance (idAccount) {
				const accountHavePay = idAccount ? this.account.filter(account => account.value === idAccount)[0].permitePagamento : null;
				if (!accountHavePay) {
					this.insufficientBalanceAccount = false;
					this.insufficientBalance = false;
					this.accountPayBalance = "0,00";
					return;
				}

				const accountBalance = idAccount ? this.account.filter(account => account.value === idAccount)[0].balance : null;
				this.accountPayBalance = accountBalance ? numberFormatted(accountBalance) : "0,00";
				this.balanceZero = this.paymentExecuteAmount === this.methodsPayAmount;

				if (parseFloat(accountBalance) > 0)
					this.insufficientBalanceAccount = false;
				else
					this.insufficientBalanceAccount = true;

				if ((this.paymentExecuteAmount != 0 && this.paymentExecuteAmount > parseFloat(accountBalance)))
					this.insufficientBalance = true;
				else
					this.insufficientBalance = false;

			},

			async paymentExecute () {
				const baixaConfirmation = (await this.$swal({
					title: "Pagar",
					text: "Tem certeza que deseja efetuar o pagamento?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (!baixaConfirmation)
					return;

				const payload = {
					idsPaymentSchedule: this.transactionToPay,
					paymentedDate: this.paymentExecuteDate,
					comments: this.paymentExecuteComments,
					methodsPay: this.havePermissionMultiAccountPay ? this.methods_pay : this.account_pay
				};

				this.$snotify.async("Aguarde...", "Efetuando pagamento", async () => {
					try {
						this.saving = true;
						await this.paymentScheduleService.executePayments({payload});

						emitter.emit("reloadAccount", { reload: true });
						if ( this.$route.path === "/")
							emitter.emit("reloadTransactions", { reload: true });

						this.$emit("saved", true);
						this.clearModal();
						return {
							title: "Sucesso!",
							body: "Pagamento efetuado com sucesso.",
							config: this.config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar efetuar pagamento.";
						throw {
							title: "Falha!",
							body: msgError,
							config: this.config
						};
					}
				});
			},


			addMethotdPay (idAccount) {
				const accountSelectBalance = parseFloat(this.account.find(ele => ele.value === idAccount)?.balance || "0.00");
				this.paymentExecuteAccount = null;
				this.accountPayBalance = "0,00";

				if (this.methods_pay.length && this.methods_pay.some(ele => ele.account.idAccount === idAccount))
					return;

				const payAmountTotal = this.paymentExecuteAmount;
				let payAmountMethod = payAmountTotal - this.methodsPayAmount;
				const description = (this.account.filter(ele => ele.value === idAccount))[0].text;

				if (payAmountMethod > accountSelectBalance)
					payAmountMethod = accountSelectBalance;

				this.methods_pay.push({
					account: { idAccount, description },
					amount_string: numberFormatted(payAmountMethod),
					amount: payAmountMethod
				});
				this.methodsPayAmount = this.methodsPayAmount + payAmountMethod;
				this.balanceZero = this.paymentExecuteAmount === this.methodsPayAmount;

				if (this.paymentExecuteAmount != parseFloat(this.methodsPayAmount))
					this.insufficientBalance = true;
				else
					this.insufficientBalance = false;

				this.invalidFormMulti = this.insufficientBalance || !this.methods_pay.length;
				this.clearSelect = !this.clearSelect;
			},

			delMethodPay (index) {
				this.methods_pay.splice(index, 1);
				this.methodsPayAmount = 0;
				this.methods_pay.forEach(ele => {
					this.methodsPayAmount = this.methodsPayAmount + ele.amount ;
				});

				if (this.paymentExecuteAmount != parseFloat(this.methodsPayAmount))
					this.insufficientBalance = true;
				else
					this.insufficientBalance = false;

				this.invalidFormMulti = this.insufficientBalance || !this.methods_pay.length;
			},

			setNewValueMethodPay (amount, index) {
				const idAccount = this.methods_pay[index].account.idAccount;
				const accountSelectBalance = parseFloat(this.account.find(ele => ele.value === idAccount)?.balance || "0.00");
				let totalPay = parseFloat((this.methods_pay.reduce((total, ele, idx) => {
					if (index === idx)
						return total;

					return total + ele.amount; }, 0)).toFixed(2)
				);

				if (amount) {
					const amountMethod = parseFloat(amount.replace(",", "."));
					totalPay += amountMethod;

					if (amountMethod > accountSelectBalance) {
						amount = accountSelectBalance.toString().replace(".", ",");
					} else {
						if (totalPay > this.paymentExecuteAmount) {
							totalPay = (totalPay - amountMethod).toFixed(2);
							amount = (this.paymentExecuteAmount - totalPay).toFixed(2).toString().replace(".", ",");
						}
					}

					this.methods_pay[index].amount_string = validateNumber(amount);
					this.methods_pay[index].amount = parseFloat(this.methods_pay[index].amount_string.replace(",", "."));
				} else {
					return;
				}

				this.methodsPayAmount = 0;
				this.methods_pay.forEach(ele => {
					this.methodsPayAmount = this.methodsPayAmount + ele.amount;
				});

				this.balanceZero = this.paymentExecuteAmount === this.methodsPayAmount || this.paymentExecuteAmount < this.methodsPayAmount;
				if (this.paymentExecuteAmount != parseFloat(this.methodsPayAmount))
					this.insufficientBalance = true;
				else
					this.insufficientBalance = false;

				this.invalidFormMulti = this.insufficientBalance || !this.methods_pay.length;
			},

			async updateValueMethodPay (value) {
				this.methods_pay.amount_string = await validateNumber(value);
				this.methods_pay.amount = this.methods_pay.amount_string.replace(",", ".");
			},

			clearModal () {
				this.paymentExecuteAccount = null;
				this.paymentExecuteComments = "";
				this.paymentExecuteDate = new Date();
				this.methods_pay = [];
				this.accountPayBalance = "0,00";
				this.insufficientBalance = false;
				this.dataPaymentsInstallments = [];
				this.insufficientBalanceAccount = true;
				this.methodsPayAmount = 0;
				this.balanceZero = false;
				this.invalidFormMulti = true;
				this.saving = false;
				this.loading = false;
				this.clearSelect = !this.clearSelect;
			},

			showPayment (transactionToPay) {
				let totalAmount = 0;
				transactionToPay.forEach(ttp => totalAmount = totalAmount + ttp.valor);

				this.paymentExecuteAmount = parseFloat(parseFloat(totalAmount).toFixed(2));
				this.paymentExecuteAmount_string = numberFormatted(totalAmount);

				this.invalidForm = true;
				this.$refs.modalPayment.show();
			},

			showAccount () {
				this.modalAccount = true;
			},

			closeAccount (cancelled) {
				if (cancelled) {
					this.nameAccount = "";
				}

				this.modalAccount = false;
			},

			setAccount (newAccount) {
				this.newAccount = {
					id: newAccount[0].idAccount,
					description: newAccount[0].description
				};
			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				if (value) {
					this.paymentExecuteAccount = value;
					//this.transactionUpsert_idAccountExpense = value;
					this.nameAccount = text;
					if (this.havePermissionMultiAccountPay) {
						this.getAccountPayBalance(value);
					} else {
						this.setMethodPay();
					}
				} else {
					this.nameAccount = text;
					this.showAccount();
				}
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
				if (!this.havePermissionMultiAccountPay) {
					this.invalidFormSearch = this.invalidSearch.account;
				} else {
					this.invalidFormSearch = false;
				}
				// if (validateSearch.invalidSearch) {
				// 	this.insufficientBalanceAccount = false;
				// 	this.insufficientBalance = false;
				// 	this.accountPayBalance = "0,00";
				// }
			},

			handleVisibleSuggestion (handleSuggestion) {
				this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
			},

			setMethodPay () {
				const idAccount = this.paymentExecuteAccount;
				const accountSelected = this.account.find(ele => ele.value === idAccount);
				const accountSelectBalance = parseFloat(accountSelected?.balance || "0.00");
				this.accountPayBalance = numberFormatted(accountSelectBalance);
				if (accountSelected.balance >= this.paymentExecuteAmount) {
					this.account_pay = [{
						account: { idAccount, description: accountSelected.description },
						amount_string: numberFormatted(this.paymentExecuteAmount),
						amount: this.paymentExecuteAmount
					}];
					this.balanceZero = true;
					this.insufficientBalance = false;
				} else {
					this.balanceZero = false;
					this.insufficientBalance = true;
				}

				this.invalidFormMulti = this.insufficientBalance || !this.account_pay.length;
			}

		}
	};
</script>